import { shareNews } from "../../../../../api/news";
import Header from "../../../../../components/header";
import { shareURL } from "../../../../../utils/common";
import { useRabbitFestivalContext } from "../../hooks/festival-context";
import { RabbitFestivalPage } from "../../hooks/use-festival-tab";
import RabbitFestivalInterviewBanner from "./components/banner";
import RabbitFestivalInterviewContent from "./components/content";
import RabbitFestivalInterviewSkeleton from "./skeleton";
import { FestivalInterviewWrapper } from "./style";

const RabbitFestivalInterview = () => {
  const {
    showHeader,
    setFestivalPage,
    interviewId,
    interviewLoading,
    setInterviewId,
  } = useRabbitFestivalContext();

  const handleShare = () => {
    if (!interviewId) return;
    shareNews(interviewId);
    shareURL(`${window.location.href}?interview=${interviewId}`);
  };

  if (interviewLoading) return <RabbitFestivalInterviewSkeleton />;

  return (
    <FestivalInterviewWrapper>
      <Header
        title="RABBIT FESTIVAL"
        show={showHeader}
        img={`/image-web/news/share${showHeader ? "_white" : ""}.svg`}
        back={() => {
          setFestivalPage(RabbitFestivalPage.MAIN);
          setInterviewId(0);
        }}
        buttonClick={handleShare}
      />
      <RabbitFestivalInterviewBanner />
      <RabbitFestivalInterviewContent />
    </FestivalInterviewWrapper>
  );
};

export default RabbitFestivalInterview;
